import { createStore, applyMiddleware } from 'redux'
import thunkMiddleware from 'redux-thunk'
import { createLogger } from 'redux-logger'
import { rootReducer } from '../reducers'

const middlewares = [
  thunkMiddleware as any,
  createLogger(),
]

const rootStore = createStore(rootReducer, applyMiddleware(...middlewares))

export default rootStore;
